module.exports = __webpack_public_path__ + "img/i_nav_find_new_off.c4986ff0.svg";